'use client';

import { TimezoneProvider } from '@/context/TimezoneContext';
import { AppProvider } from './globalContext';
import { WebSessionProvider } from '@/context/WebSessionContext';
import type { SessionType } from '@/util/types/globalTypes';
import AttikObservabilityScope from '@/components/observability/AttikObservabilityScope';

export default function Providers({
  children,
  companyTimezone,
  initialSession = null,
}: {
  children: React.ReactNode;
  companyTimezone: string | null;
  initialSession?: SessionType | null;
}) {
  return (
    <WebSessionProvider initialSession={initialSession}>

      <AttikObservabilityScope />
      <TimezoneProvider timezone={companyTimezone}>
        <AppProvider>{children}</AppProvider>
      </TimezoneProvider>
    </WebSessionProvider>
  );
}
